// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"021a47d5","966":"a08d2b25"}[chunkId] + ".chunk.js";
};